import { Box } from "@mui/material";
import {
  RO_DETAIL_COLORS,
  RO_DETAIL_LAYOUT,
} from "../../data/inRepairRoDetailConstants";

const RoDetailCard = ({ children, sx, borderLeftColor }) => (
  <Box
    sx={{
      background: RO_DETAIL_COLORS.cardBg,
      border: `1px solid ${RO_DETAIL_COLORS.border}`,
      borderRadius: RO_DETAIL_LAYOUT.cardRadius,
      padding: RO_DETAIL_LAYOUT.cardPadding,
      ...(borderLeftColor && {
        borderLeft: `${RO_DETAIL_LAYOUT.cardBorderLeftWidth} solid ${borderLeftColor}`,
      }),
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default RoDetailCard;
